export const blockIconsSocialTravelExploreNew = (
	<span className='material-symbols-outlined'>travel_explore</span>
);
